<div class="tools-buttons-container">
  <div *ngIf="allowedParts.allowedTools.includes(ToolsEnum.geocoder)" class="button-container2" id="mapSearcher">
    <img src="../../../assets/img/navBar/busqueda.svg" (click)="openGeocoder()" class="img-button" matTooltip="Activar buscador de direcciones" matTooltipPosition="left">

    <div [@mostrarGeocodificador]="this.isGeocoderActive ? 'visible' : 'hidden'" class="geocoder-container">
      <geocoder [resetComponent]="!isGeocoderActive" [layerDisplaySuffix]="'buscador principal'"></geocoder>
    </div>
  </div>

  <div *ngIf="allowedParts.allowedTools.includes(ToolsEnum.layersPanel)" class="button-container2" id="mapLayers">
    <img *ngIf="this.isLayersPanelActive" [src]="'icon_capas.svg' | findUrl" (click)="toggleLayersPanel()" class="img-button" matTooltip="Abrir panel de capas" matTooltipPosition="left">
    <img *ngIf="!this.isLayersPanelActive" [src]="'icon_capas.svg' | findUrl" (click)="toggleLayersPanel()" class="img-button" matTooltip="Abrir panel de capas" matTooltipPosition="left">

    <div [@mostrarCapas]="this.isLayersPanelActive ? 'visible' : 'hidden'" class="layers-buttons-container">
      <div class="layers-panel-header">
        <span class="layers-panel-title">Carga manual de capas</span>
        <button class="layers-panel-close-btn" (click)="toggleLayersPanel()" matTooltip="Cerrar panel de capas">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>

      <div class="layers-panel-content">
        <panel-internal-layers *ngIf="allowedParts.allowedTools.includes(ToolsEnum.internalLayersPanel)" class="button-container" ></panel-internal-layers>
        <panel-external-layers *ngIf="allowedParts.allowedTools.includes(ToolsEnum.externalLayersPanel)" [ngClass]="{'disabled': layerService.isExternalLayersButtonDisabled}" class="button-container"></panel-external-layers>
        <panel-map-layers *ngIf="allowedParts.allowedTools.includes(ToolsEnum.mapLayersPanel)" [ngClass]="{'disabled': layerService.isMapLayersButtonDisabled}" class="button-container"></panel-map-layers>
      </div>

      <div class="layers-panel-footer">
        <!-- <mat-icon class="layers-panel-footer-icon">schedule</mat-icon> -->
        <span>Agrega o recarga una capa</span>
      </div>
    </div>
  </div>

  <div *ngIf="allowedParts.allowedTools.includes(ToolsEnum.reposition)" class="button-container2" id="mapCenter">
    <img src="../../../assets/img/navBar/centrar_icon.svg" (click)="centerMap()" class="img-button" matTooltip="Centrar mapa" matTooltipPosition="left">
  </div>

  <div *ngIf="allowedParts.allowedTools.includes(ToolsEnum.carSelector)">
    <tool-cars-selector class="button-container2"></tool-cars-selector>
  </div>
  <div *ngIf="allowedParts.allowedTools.includes(ToolsEnum.streetInfo)">
    <tool-street-info-box class="button-container2"></tool-street-info-box>
  </div>
</div>

<div *ngIf="allowedParts.allowedTools.includes(ToolsEnum.annotationsLayer)" class="annotation-container">
  <annotation-layer-general-management></annotation-layer-general-management>
</div>





<!-- cuadro para mostrar el street view al hacer clic en el mapa -->
<div *ngIf="showStreetViewBox" class="info-box">
  <button class="close-btn" (click)="closeInfoBox()">x</button>
  <img (click)="openStreetView()" class="col-5" src="assets/img/street-view-bg.png" alt="Imagen">
  <div class="info-text col-9">
    <h3>{{ streetViewBoxTitle }}</h3>
    <p (click)="openStreetView()">{{ streetViewBoxDescription }}</p>
  </div>
</div>